import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ICareerProspects {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  sub_title?: string;
  sub_title_text_color?: string;
  cta_text?: string;
  cta_text_color?: string;
  cta_background_color?: string;
  cta_icon?: string;
  cta_icon_alt?: string;
  background_color?: string;
  note_text?: string;
  note_text_color?: string;
  certificate_image?: string;
  certificate_image_mobile?: string;
  certificate_image_alt?: string;
  background_image?: string;
  variant?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createCareerProspects(payload: Partial<ICareerProspects>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.CAREER_PROSPECTS.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateCareerProspects(id: number, payload: Partial<ICareerProspects>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.CAREER_PROSPECTS.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

